/**
 * @fileoverview GET handler for the "/engagement/campaign_email_click_daily_stats/:campaign_id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementCampaignEmailClickDailyStatsCampaignId } from "./constants";
import type { CampaignEmailClickDailyStatsResult, CampaignEmailClickDailyStatsParams } from "./types";

export const getCampaignEmailClickDailyStats = reactQueryFetcherAdapter(
  engagementCampaignEmailClickDailyStatsCampaignId,
  (
    signal: AbortSignal,
    { campaignId, start, end, isAmp }: CampaignEmailClickDailyStatsParams
  ): Promise<CampaignEmailClickDailyStatsResult> => {
    return fetch(
      `/engagement/campaign_email_click_daily_stats/${campaignId}`,
      "GET",
      { start, end, is_amp: isAmp },
      { signal }
    );
  }
);
